import type { TableConfig } from './gameClient';

const SESSIONS_KEY = 'poker-table-sessions';
const LEGACY_KEY = 'poker-table-session';

export interface SavedTableSession {
  reconnectionToken: string;
  tableId: string;
  config: TableConfig;
  userId: string;
}

export function saveTableSession(session: SavedTableSession): void {
  try {
    const sessions = getTableSessions();
    const idx = sessions.findIndex((s) => s.tableId === session.tableId);
    if (idx >= 0) sessions[idx] = session;
    else sessions.push(session);
    localStorage.setItem(SESSIONS_KEY, JSON.stringify(sessions));
  } catch {
    // localStorage may be unavailable
  }
}

export function getTableSessions(): SavedTableSession[] {
  try {
    const raw = localStorage.getItem(SESSIONS_KEY);
    if (raw) return JSON.parse(raw) as SavedTableSession[];
    // Migrate from legacy single-session key
    const legacy = localStorage.getItem(LEGACY_KEY);
    if (legacy) {
      const session = JSON.parse(legacy) as SavedTableSession;
      localStorage.removeItem(LEGACY_KEY);
      localStorage.setItem(SESSIONS_KEY, JSON.stringify([session]));
      return [session];
    }
    return [];
  } catch {
    return [];
  }
}

/** Returns first session, or the session for a specific tableId */
export function getTableSession(tableId?: string): SavedTableSession | null {
  const sessions = getTableSessions();
  if (tableId) return sessions.find((s) => s.tableId === tableId) ?? null;
  return sessions[0] ?? null;
}

export function removeTableSession(tableId: string): void {
  try {
    const sessions = getTableSessions().filter((s) => s.tableId !== tableId);
    localStorage.setItem(SESSIONS_KEY, JSON.stringify(sessions));
  } catch {
    // ignore
  }
}

export function clearTableSession(): void {
  try {
    localStorage.removeItem(SESSIONS_KEY);
    localStorage.removeItem(LEGACY_KEY);
  } catch {
    // ignore
  }
}
